
export interface ParameterType<T> { pk?: number; nombre: string; valor: T; }

export interface ColorsElement { pk?: number; codigo: string; has_change?: boolean; }

export type PaletteColorKey =
    | 'COLORS_SITES__CLARO_1'
    | 'COLORS_SITES__CLARO_2'
    | 'COLORS_SITES__CLARO_3'
    | 'COLORS_SITES__OSCURO_1'
    | 'COLORS_SITES__OSCURO_2'
    | 'COLORS_SITES__OSCURO_3';

export type DarkOverrideKey =
    | 'COLORS_SITES__DARK_OVERRIDE_1'
    | 'COLORS_SITES__DARK_OVERRIDE_2'
    | 'COLORS_SITES__DARK_OVERRIDE_3'
    | 'COLORS_SITES__DARK_OVERRIDE_4'
    | 'COLORS_SITES__DARK_OVERRIDE_5'
    | 'COLORS_SITES__DARK_OVERRIDE_6';

export type ColorSettingKey = PaletteColorKey | DarkOverrideKey;

export type ColorsParameterMap = Partial<Record<PaletteColorKey, ColorsElement>> &
    Partial<Record<DarkOverrideKey, ColorsElement>> &
    Record<string, ColorsElement | undefined>;

export const PALETTE_COLOR_KEYS: readonly PaletteColorKey[] = [
    'COLORS_SITES__CLARO_1',
    'COLORS_SITES__CLARO_2',
    'COLORS_SITES__CLARO_3',
    'COLORS_SITES__OSCURO_1',
    'COLORS_SITES__OSCURO_2',
    'COLORS_SITES__OSCURO_3',
];

export const DARK_OVERRIDE_KEYS: readonly DarkOverrideKey[] = [
    'COLORS_SITES__DARK_OVERRIDE_1',
    'COLORS_SITES__DARK_OVERRIDE_2',
    'COLORS_SITES__DARK_OVERRIDE_3',
    'COLORS_SITES__DARK_OVERRIDE_4',
    'COLORS_SITES__DARK_OVERRIDE_5',
    'COLORS_SITES__DARK_OVERRIDE_6',
];

export const colorsNumber: Record<PaletteColorKey, number> = {
    COLORS_SITES__CLARO_1: 1,
    COLORS_SITES__CLARO_2: 2,
    COLORS_SITES__CLARO_3: 3,
    COLORS_SITES__OSCURO_1: 4,
    COLORS_SITES__OSCURO_2: 5,
    COLORS_SITES__OSCURO_3: 6,
};

export const DEFAULT_LIGHT_PALETTE_FALLBACK: readonly string[] = [
    '#f6f6e8',
    '#fcfaf7',
    '#ffffff',
    '#969696',
    '#90a4ae',
    '#607d8b',
];

export const isDarkOverrideKey = (value: string): value is DarkOverrideKey =>
    (DARK_OVERRIDE_KEYS as readonly string[]).includes(value);

export const isPaletteColorKey = (value: string): value is PaletteColorKey =>
    (PALETTE_COLOR_KEYS as readonly string[]).includes(value);
